export default [
    {
        name: 'SearchDesign',
        path: 'SearchDesign',
        component: () => import('@/pages/Trademark/SearchDesign'),
        meta: { title: '查询与设计' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
              
            }
        }
    },
    {
        name: 'Renewal',
        path: 'Renewal',
        component: () => import('@/pages/Trademark/Renewal'),
        meta: { title: '续展与变更' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    },
    {
        name: 'NonCancellation',
        path: 'NonCancellation',
        component: () => import('@/pages/Trademark/NonCancellation'),
        meta: { title: '异议与撤三' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    },
    {
        name: 'AnswerReview',
        path: 'AnswerReview',
        component: () => import('@/pages/Trademark/AnswerReview'),
        meta: { title: '答辩与复审' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    },
    {
        name: 'Surveillance',
        path: 'Surveillance',
        component: () => import('@/pages/Trademark/Surveillance'),
        meta: { title: '监测与维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    },
]